<div class="search-page-container">
    <div class="search-header">
        <div class="header-content">
            <div class="search-title-group">
                <div class="search-section">
                    <div class="search-container" *ngIf="isImplantProducts">
                        <div class="search-controls">
                            <form class="search-block" (submit)="onSearchSubmit()">
                                <div class="search-input">
                                    <input type="text" name="search" [(ngModel)]="searchInput" placeholder="Search by Product name and batch number">
                                </div>
                                <button type="submit" class="icon-btn">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                                    </svg>
                                </button>
                            </form>
                            <button type="button" class="reset-btn" (click)="reset($event)">
                                Reset
                            </button>
                        </div>
                    </div>
                </div>
                
                <div class="title-section">
                    <h1 class="page-title">Total {{ implantType }} Implants: {{ totalImplants }}</h1>
                </div>
            </div>
        </div>

    <div class="table-container">
        <div class="table-wrapper">
            <table class="data-table">
                <thead>
                    <tr class="table-header">
                        <th class="header-cell">Product Code</th>
                        <th class="header-cell">Product Name</th>
                        <th class="header-cell">Batch Number</th>
                        <th class="header-cell">Expiry Date</th>
                        <th class="header-cell" *ngIf="implantType !== 'low_stocks'">Cabinet</th>
                        <th class="header-cell" *ngIf="implantType == 'low_stocks'">Stock Qty</th>
                        <th class="header-cell">
                            {{ implantType !== 'consumed' ? 'Last Updated' : 'Consumed Date' }}
                        </th>
                    </tr> 
                </thead>
                <tbody *ngIf="isFilterResult" class="table-body">
                    <tr *ngFor="let product of implantProducts" 
                        class="table-row"
                        (click)="(implantType !== 'low_stocks') ? openDialog(product.store_id, product.product_stock_id) : openLowStockDialog(product.store_id,product.id)">
                        <td class="data-cell product-code">{{ product.product_code }}</td>
                        <td class="data-cell product-name">{{ product.name }}</td>
                        <td class="data-cell batch-number">{{ product.batch_no || product.batch_number || product.batchNumber || product.batch || 'N/A' }}</td>
                        <td class="data-cell expiry-date">{{ formatDate(product.expiry_date) }}</td>
                        <td class="data-cell cabinet" *ngIf="implantType !== 'consumed' && implantType !== 'low_stocks'">
                            <a [routerLink]="'/home/stocks/cabinets/' + product.cabinet_id" 
                               class="cabinet-link" 
                               *ngIf="product.cabinet_name">
                                {{ product.cabinet_name }}
                            </a>
                            <span class="cabinet-text" *ngIf="!product.cabinet_name">At Store</span>
                        </td>
                        <td class="data-cell stock-qty" *ngIf="implantType == 'low_stocks'">{{ product.stock_qty }}</td>
                        <td class="data-cell last-updated">{{ formatDate(product.last_updated_at) }}</td>
                    </tr>
                </tbody>
                <tbody *ngIf="!isFilterResult" class="table-body">
                    <tr class="no-results-row">
                        <td colspan="7" class="no-results-cell">
                            <div class="no-results-content">
                                <div class="no-results-icon">
                                    <i class="fa fa-search"></i>
                                </div>
                                <h3 class="no-results-title">No records were found</h3>
                                <p class="no-results-subtitle">Try adjusting your search criteria</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="pagination-container" *ngIf="totalPages > 1 && isImplantProducts">
            <app-pagination [totalPages]="totalPages" (queryPage)="getQueryPage($event)"></app-pagination>
        </div>
    </div>
</div>

<app-toast-message></app-toast-message> 